import Training from '../../components/onboarding/training.vue';

export default {
    path: '/training/:id',
    component: Training,
    meta: {
        requiresAuth: false,
        showProgress: true,
        hideHeaderButtons: true,
        hideFooter: true,
    },
}
